package com.devi3east.bashbuddy.auth.domain.models

enum class SignUpStep {
    ACCOUNT,
    DETAILS,
    SUPPORT,
    LEGAL
}